
import React, { useState, useEffect, useContext, useRef } from 'react';
import { classNames } from 'primereact/utils';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { MultiSelect } from 'primereact/multiselect';
import { Tag } from 'primereact/tag';
import { TriStateCheckbox } from 'primereact/tristatecheckbox';
import { Button } from "@nextui-org/react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faX, faArrowsRotate, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { Modal, ModalContent, ModalHeader, ModalBody, ModalFooter, useDisclosure } from "@nextui-org/react";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Col, Row } from 'react-bootstrap';
import RequestPdf from './RequestPdf';
import { Toast } from 'primereact/toast';
import { motion } from 'framer-motion'
import "../StaffPanel.css"
import DocViewerComp from './DocVIewer/DocViewerComp';
import FormComponent from '../../components/FormComponents/FormComponent';
import axios from 'axios';
import BackEndUrl from '../../backURL';
import * as Yup from 'yup';
import { StaffContext } from '../Services/staff.context';
import { useFormik } from 'formik';
import { w3cwebsocket as W3CWebSocket } from "websocket";
import moment from 'moment-timezone';
const backend_ = BackEndUrl.domain;
const modified_backend_Url = backend_.replace(/^https:\/\//, '');
const client = new W3CWebSocket('wss://'+modified_backend_Url);
client.onopen = () => { };

export default function DataListContactUs({ setselectedReq }) {
  const backend = BackEndUrl.domain;
  const toast = useRef(null);
  const [data, setData] = useState(null);
  const [dataSorted, setDataSorted] = useState(null);
  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    req_id: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    contact_no: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    req_status: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    req_message: { value: null, matchMode: FilterMatchMode.CONTAINS },
    id: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    req_status_time: { value: null, matchMode: FilterMatchMode.STARTS_WITH },

  });
  const [loading, setLoading] = useState(true);
  const [globalFilterValue, setGlobalFilterValue] = useState('');
  const { isOpen, onOpen, onOpenChange, onClose } = useDisclosure();
  const [selectedDataRow, SetSelectedDataRow] = useState(null);
  const [alteredData, SetAlternateData] = useState();

  const [isRMOpen, setRMOpen] = useState(false)
  const pendingReqs = useContext(StaffContext).pendingRequests
  const GetPendingReqs = useContext(StaffContext).getPendingReq
  const GetRejectedReq = useContext(StaffContext).getRejectedReq
  const GetAcceptedReqs = useContext(StaffContext).getAcceptedReq

  const pendingReqsContactUs = useContext(StaffContext).pendingRequestsContactUs


  const formatDate = (dateString) => {
    // Parse the date string in UTC
    const utcDate = moment.utc(dateString);
  
    // Convert to Asia/Colombo timezone but keep the same time
    const colomboDate = utcDate.tz('Asia/Colombo', true);
  
    // Format the date
    return colomboDate.format('YYYY-MM-DD HH:mm:ss');
  };

  useEffect(() => {


    //console.log(pendingReqsContactUs);
    const formattedData = pendingReqsContactUs && pendingReqsContactUs.map((value) => {

      return {
        "id": value.id,
        "req_id": value.req_id,
        "contact_no": value.contact_no,
        "req_status": value.req_status,
        "req_message": value.req_message,
        "req_time": formatDate(value.req_time),
        "req_status_time": value.req_status_time,
        "timestamp": value.timestamp,
        "req_status_reason": value.req_status_reason,
        "correct_contact_no": value.correct_contact_no,
//moment(value.req_time).tz('Asia/Colombo').format('YYYY-MM-DD HH:mm:ss'),
      };
    });

    // Sort by req_created_time
    const sortedRequstedData = formattedData.sort((a, b) => {
      return new Date(b.req_time) - new Date(a.req_time);
    });

    setDataSorted(sortedRequstedData);
    
        if (formattedData) {

          setData(formattedData);
          setLoading(false);
        }
      }, [pendingReqsContactUs]);

  async function alteredDataLoad(req_id) {
    try {
      const response = await axios.post(backend + "/alteration_data_load", {
        req_id: req_id,


      }, {
        headers: {
          Authorization: sessionStorage.getItem('staff-token'),
        }
      });
      SetAlternateData(response.data);


    } catch (err) {

    }


  }
  async function onResponse(id,req_id, req_status, req_status_reason, correct_contact_no, formik) {
    if (req_status == "reject") {
      formik.validateForm().then(async (errors) => {

        if (Object.keys(errors).length === 0) {
          try {
            const response = await axios.post(backend + "/change-response-contact", {
              id: id,
              req_id: req_id,
              type: req_status,
              reason: req_status_reason,
              correctcontactno: correct_contact_no             

            }, {
              headers: {
                Authorization: sessionStorage.getItem('staff-token'),
              }
            })
            if (response.status == 200) {
              client.send(JSON.stringify({
                type: "message",
                msg: "status changed",

              }));
              setRMOpen(false)
              onClose()
              GetPendingReqs()
              GetRejectedReq()
            }
          }
          catch (err) {
            console.log(err)

          }



        }
        else {
          toast.current.clear();
          toast.current.show({
            severity: 'error',
            summary: 'Invalid or mising information',
            description: "please check the given information",
            life: 3000,
            sticky: false,
            content: (props) => (
              <div className="p-3" style={{ flex: '1' }}>
                <div className="" style={{ fontSize: "2.5dvh" }}>{props.message.summary}</div>
                <div className="" style={{ fontSize: "2dvh" }}>{props.message.description}</div>
              </div>
            ),
          });
        }
      })

    } else if (req_status == "complete") {


      try {
        const response = await axios.post(backend + "/change-response-contact", {
          id: id,
          req_id: req_id,
          type: req_status,
          reason: req_status_reason,
          correctcontactno: correct_contact_no

        }, {
          headers: {
            Authorization: sessionStorage.getItem('staff-token'),
          }
        })
        if (response.status == 200) {
          client.send(JSON.stringify({
            type: "message",
            msg: "status changed",

          }));

          setRMOpen(false)
          onClose()

          GetPendingReqs()

          GetAcceptedReqs()


        }
      }
      catch (err) {
        console.log(err)

      }






    }

  }
//OnResponse finish

  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };

    _filters['global'].value = value;

    setFilters(_filters);
    setGlobalFilterValue(value);
  };

  const renderButtonAcceptColumn = (rowData) => {

    return (
      <Button isIconOnly variant="faded" >

        <FontAwesomeIcon color="#4DB925" icon={faCheck} />
      </Button>

    );
  };
  const renderButtonRejectColumn = (rowData) => {

    return (
      <Button isIconOnly variant="faded">

        <FontAwesomeIcon icon={faX} color="red" />
      </Button>

    );
  };


  const formikContactNo = useFormik({
    initialValues: {
      correctcontactno: '',
    },
    validationSchema: Yup.object({
      correctcontactno: Yup.string().required('*Required'),
    }),


  });

  const handleReset = () => {
    formikContactNo.resetForm();
  };

  const renderDetailsColumn = (rowData) => {

    return (
      <Button style={{backgroundColor:"#FF9843"}} variant="faded" onPress={onOpen} onClick={() => { handleReset(); SetSelectedDataRow(rowData); alteredDataLoad(rowData?.id) }}>

        Details
      </Button>

    );
  };
  const renderHeader = () => {
    return (
      <div className="flex justify-content-end">
        <span className="p-input-icon-left">
          <i className="pi pi-search" />
          <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Keyword Search" style={{ padding: "1vh", margin: "1vh" }} />
        </span>
      </div>
    );
  };


  const renderRefreshbtn = () => {
    return (
      <div style={{ paddingLeft: "1.5vw", paddingRight: "1.5vw" }}>
        <Button onClick={() => { GetPendingReqs() }}>
          <FontAwesomeIcon icon={faArrowsRotate} />
        </Button>
      </div>
    )

  }
  const Refreshbtn = renderRefreshbtn();

  const header = renderHeader();

  

  const RejectModal = React.memo(({ isOpen, setRMOpen, id,req_id, mobile }) => {


    const formik = useFormik({
      initialValues: {
        reason: ''
      },
      validationSchema: Yup.object({
        reason: Yup.string().required('*Required'),
      }),


    });


   



    const onClose = () => {
      setRMOpen(false);

    };

    ////// Reject Dialog Box
    return (
      <Modal size="md" isOpen={isOpen} onClose={onClose}>
        <ModalContent>
          <>   <Toast ref={toast} style={{ zIndex: "1000" }} position="top-center" />
            <ModalHeader className="flex flex-col gap-1">Reason for Rejection</ModalHeader>
            <ModalBody>
              <h2>SMS rejection to : {mobile}</h2>
              <FormComponent
                type="text-area"
                value={formik.values.reason}
                onChange={formik.handleChange}
                name={"reason"}
                errors={formik.errors.reason}
              />
            </ModalBody>
            <ModalFooter>
              <Button variant="light" onPress={onClose}>
                Cancel
              </Button>
              <Button color="danger" onClick={() => onResponse(id,req_id, 'reject', formik.values.reason, mobile, formik)}>
                Reject
              </Button>
            </ModalFooter>
          </>
        </ModalContent>
      </Modal>
    );
  });
   ////// Reject Dialog Box

   const statusBodyTemplate = (rowData) => {
    let backgroundColor;
    switch (rowData.req_status.toLowerCase()) {
      case 'complete':
        backgroundColor = '#337357';
        break;
      case 'reject':
        backgroundColor = '#EE4266';
        break;
      case 'pending':
        backgroundColor = '#FFAF00';
        break;
      default:
        backgroundColor = '#8C6A5D'; // Default color if status is unknown
    }

    return (
      <span style={{ 
        textTransform: 'uppercase', 
        color: 'white', 
        backgroundColor: backgroundColor, 
        borderRadius: '4px', 
        padding: '4px', 
        display: 'inline-block' 
      }}>
        {rowData.req_status}
      </span>
    );
  };

  ////// Requst Details Dialog Box
  return (

    <div className="card" >
      <>
        <Modal isOpen={isOpen} onOpenChange={onOpenChange} size={"5xl"} >
          <ModalContent style={{ height: "70vh" }} className='modal-scroll-bar'  >
            {(onClose) => (
              <>
                <ModalHeader className="flex flex-col gap-1" style={{ backgroundColor: "#F7941E", fontSize: "1.7rem", color: "white" }}>Contact Us : Request Details</ModalHeader>
                <ModalBody className=' modal-overflow'    >

                  
                  <table>
                  <tr style={{backgroundColor:"#C9DABF"}}>
                    <th style={{width:"30%", padding:"5px"}}>Request Status</th>
                    <th  style={{textTransform: "uppercase"}}>{selectedDataRow && selectedDataRow?.req_status}</th>
                  </tr>

                    {(selectedDataRow && selectedDataRow?.req_status == 'reject')? <tr style={{backgroundColor:"#C9DABF"}}>
                    <th style={{width:"30%", padding:"5px" , color:"red"}}>Reject Reason</th>
                    <th style={{textTransform:"uppercase" , color:"red"}}>{selectedDataRow && selectedDataRow?.req_status_reason}</th>
                  </tr> : null}              


                  <tr>
                    <th style={{width:"30%", padding:"5px"}}>Req ID</th>
                    <th>{selectedDataRow && selectedDataRow?.req_id}</th>
                  </tr>
                  <tr style={{backgroundColor:"#C9DABF"}}>
                    <th style={{width:"30%", padding:"5px"}}>Req Contact</th>
                    <th>0{selectedDataRow && selectedDataRow?.contact_no}</th>
                  </tr>
                  <tr>
                    <th style={{width:"30%", padding:"5px"}}>Req Message</th>
                    <th>{selectedDataRow && selectedDataRow?.req_message}</th>
                  </tr>
                  <tr style={{backgroundColor:"#C9DABF"}}>
                    <th style={{width:"30%", padding:"5px"}}>Req Time</th>
                    <th>{selectedDataRow && selectedDataRow?.req_time}</th>
                  </tr>
                  {(selectedDataRow && selectedDataRow?.req_status != 'reject' && selectedDataRow && selectedDataRow?.req_status != 'complete')? <tr>
                    <th style={{fontSize:"15px"}}>Contact No<br></br><span style={{fontSize:"13px"}}>* Please Confirm the phone number</span></th>
                    <th >
                      <FormComponent
                      type="input-number"
                      value={formikContactNo.values.correctcontactno}
                      onChange={formikContactNo.handleChange}
                      name={"correctcontactno"}
                      errors={formikContactNo.errors.correctcontactno}
                      style={{height:"6vh"}}
                    />
                    </th>
                  </tr> : null }
                  
                </table>
                

                </ModalBody>
                <ModalFooter>

                  <RequestPdf data={selectedDataRow} alt_data={alteredData} />

                  {(formikContactNo.values.correctcontactno.length == 10 && selectedDataRow && selectedDataRow?.req_status != "complete" && selectedDataRow?.req_status != "reject")? <Button color="success" style={{ color: "white" }} onClick={() => onResponse(selectedDataRow && selectedDataRow.id,selectedDataRow && selectedDataRow.req_id, 'complete', "Request Completed", formikContactNo.values.correctcontactno)}>
                    Complete
                  </Button> : null }
                  
                  {(formikContactNo.values.correctcontactno.length == 10 && selectedDataRow && selectedDataRow?.req_status != "complete" && selectedDataRow?.req_status != "reject" )?<Button color="danger" style={{ color: "white" }} onPress={() => { setRMOpen(true) }}>
                    Reject
                  </Button> : null }
                  <Button color="danger" variant="light" onPress={onClose}>
                    Close
                  </Button>
                </ModalFooter>
              </>
            )}
          </ModalContent>
        </Modal>
        <RejectModal isOpen={isRMOpen} setRMOpen={setRMOpen} id={selectedDataRow && selectedDataRow.id} req_id={selectedDataRow && selectedDataRow.req_id} mobile={formikContactNo.values.correctcontactno}  />

        <Row className='justify-content-start d-flex' style={{ width: "100%" }}>

          <Col xs={1} className='my-3 justify-content-start d-flex mx-3'>
            <motion.div
              whileTap={{
                scale: 0.9
              }}
              onClick={() => { setselectedReq(null) }}
            >
              <FontAwesomeIcon icon={faArrowLeft} />
            </motion.div>
          </Col>
          <Col xs={10} className='justify-content-center '>
          <h1 style={{fontSize:"20px", fontWeight:"bold" ,textAlign:"center",marginTop:"20px", marginBottom:"20px"}}>PENDING REQUEST</h1>
          </Col>

        </Row>
        <DataTable value={dataSorted} paginator rows={10} dataKey="id" filters={filters} filterDisplay="row" loading={loading}
          globalFilterFields={['req_id', 'req_time', 'req_message', 'req_status', 'contact_no']} header={header} emptyMessage="No requests found." stripedRows style={{ padding: "15px", backgroundColor: "#F9FAFB" }}>
          <Column body={renderDetailsColumn} header={Refreshbtn} style={{ textAlign: 'center', width: '8rem' }} />
          <Column field="req_id" header="Request ID" filter filterPlaceholder="Search by request ID" style={{ minWidth: '12rem' }} />
          <Column field="req_time" header="Req time" filter filterPlaceholder="Search by Req Time" style={{ minWidth: '12rem' }} />
          <Column field="req_message" header="Req Message" filter filterPlaceholder="Search by Message" style={{ minWidth: '12rem' }} />
          <Column field="req_status" header="Req Status" filter filterPlaceholder="Search by Status" body={statusBodyTemplate}
        style={{ minWidth: '12rem' }} />
          <Column field="contact_no" header="Contact Number" filter filterPlaceholder="Search by conatct number" style={{ minWidth: '12rem' }} />
         
        </DataTable>
      </>
    </div>
  );
   ////// Requst Details Dialog Box
}
